import {
  SET_ITENS, LOADING,
} from './mutations.type';

export default {
  [SET_ITENS](state, itens) {
    state.itens = itens;
  },
  [LOADING](state, loading) {
    state.loading = loading;
  },
};
